import {
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Stack,
  Typography,
} from "@mui/material";
import TopHeadingDividerComponent from "../AccountSetting/TopHeadingDividerComponent";
import CustomizedRadios from "./CustomizedRadios";
import SaveChangingsButton from "../AccountSetting/SaveChangingsButton";
const texts = ["Who Can Message You", "How People Can Find You"];
function CommunicationSection() {
  return (
    <Stack
      sx={{
        bgcolor: "#ffffff",
        p: "20px",
        borderRadius: "20px",
        pb: "100px",
      }}
    >
      <TopHeadingDividerComponent
        primary="Who can connect with you?"
        secondary="He moonlights difficult engrossed it, sportsmen. Interested has all Devonshire difficulty gay assistance joy. Unaffected at ye of compliment alteration to."
      />
      <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        <Stack
          sx={{
            bgcolor: "#F8F8F8",
            p: "20px",
            py: "23px",
            borderRadius: "10px",
            //   pb: "100px",
            border: "1px solid #E3E3E3",
          }}
        >
          <CustomizedRadios />
        </Stack>
        {texts.map((text) => (
          <Stack
            sx={{
              bgcolor: "#FFFfff",
              p: "16px",
              borderRadius: "10px",
              border: "1px solid #E3E3E3",
            }}
          >
            <Typography
              variant="body2"
              sx={{
                fontSize: "16px",
                fontWeight: "500",
                lineHeight: "19.36px",
              }}
            >
              {text}
            </Typography>
          </Stack>
        ))}
      </Box>
      <SaveChangingsButton alignSelf="end" mt="28px">
        Save Changings
      </SaveChangingsButton>
    </Stack>
  );
}

export default CommunicationSection;
